export const projects = [
  {
    client_id: 1,
    description: "In mi pede, nonummy ut, molestie in, tempus",
    project_number: "P-1",
    id: 1,
    color: "#db6967",
    is_favorite: true,
    last_updated_on: "2020-08-08",
    client_name: "Enim Mauris LLP",
    name: "Nullam velit dui,",
  },
  {
    client_id: 1,
    description:
      "sagittis placerat. Cras dictum ultricies ligula. Nullam enim. Sed",
    project_number: "P-2",
    id: 2,
    color: "#ed703b",
    is_favorite: true,
    last_updated_on: "2021-11-15",
    client_name: "Vel LLC",
    name: "porttitor vulputate, posuere",
  },
  {
    client_id: 2,
    description:
      "aliquet diam. Sed diam lorem, auctor quis, tristique ac, eleifend vitae,",
    project_number: "P-3",
    id: 3,
    color: "#76f2b8",
    is_favorite: false,
    last_updated_on: "2022-01-08",
    client_name: "Ipsum Suspendisse Non Limited",
    name: "Cum sociis natoque",
  },
  {
    client_id: 2,
    description: "velit justo nec ante. Maecenas mi felis,",
    project_number: "P-4",
    id: 4,
    color: "#c3ed6f",
    is_favorite: false,
    last_updated_on: "2019-12-13",
    client_name: "Nunc Mauris Corp.",
    name: "Suspendisse tristique neque venenatis",
  },
  {
    client_id: 1,
    description: "ipsum non arcu.",
    project_number: "P-5",
    id: 5,
    color: "#328499",
    is_favorite: false,
    last_updated_on: "2020-10-16",
    client_name: "At Associates",
    name: "Nunc ut erat.",
  },
  {
    client_id: 1,
    description: "commodo at, libero. Morbi",
    project_number: "P-6",
    id: 6,
    color: "#497703",
    is_favorite: false,
    last_updated_on: "2022-02-12",
    client_name: "Elit Dictum Foundation",
    name: "Nullam suscipit, est",
  },
  {
    client_id: 2,
    description: "felis purus ac tellus. Suspendisse sed dolor.",
    project_number: "P-7",
    id: 7,
    color: "#fcae9f",
    is_favorite: true,
    last_updated_on: "2020-11-08",
    client_name: "Mauris Inc.",
    name: "nec ante blandit",
  },
  {
    client_id: 2,
    description: "vel sapien imperdiet ornare.",
    project_number: "P-8",
    id: 8,
    color: "#5befb1",
    is_favorite: true,
    last_updated_on: "2020-09-05",
    client_name: "Morbi Metus Industries",
    name: "ridiculus mus.",
  },
  {
    client_id: 1,
    description: "libero est, congue a, aliquet vel, vulputate",
    project_number: "P-9",
    id: 9,
    color: "#01c6a2",
    is_favorite: true,
    last_updated_on: "2021-06-14",
    client_name: "A Enim Suspendisse Inc.",
    name: "risus. Duis",
  },
  {
    client_id: 1,
    description: "Ut nec urna et arcu imperdiet ullamcorper.",
    project_number: "P-10",
    id: 10,
    color: "#82e25d",
    is_favorite: true,
    last_updated_on: "2021-11-16",
    client_name: "Duis At LLC",
    name: "luctus ut, pellentesque",
  },
  {
    client_id: 2,
    description: "ac facilisis facilisis, magna",
    project_number: "P-11",
    id: 11,
    color: "#948fe8",
    is_favorite: false,
    last_updated_on: "2020-07-27",
    client_name: "Penatibus Et Foundation",
    name: "Phasellus nulla. Integer vulputate,",
  },
  {
    client_id: 2,
    description: "convallis, ante lectus convallis est, vitae sodales nisi",
    project_number: "P-12",
    id: 12,
    color: "#13f735",
    is_favorite: true,
    last_updated_on: "2021-08-04",
    client_name: "Ac Feugiat Inc.",
    name: "Integer id magna et",
  },
  {
    client_id: 1,
    description: "sed leo. Cras vehicula aliquet libero.",
    project_number: "P-13",
    id: 13,
    color: "#c547f7",
    is_favorite: true,
    last_updated_on: "2021-01-18",
    client_name: "Vitae Aliquam Company",
    name: "nunc ac",
  },
  {
    client_id: 1,
    description:
      "eget tincidunt dui augue eu tellus. Phasellus elit pede, malesuada vel, venenatis vel,",
    project_number: "P-14",
    id: 14,
    color: "#fff7b2",
    is_favorite: true,
    last_updated_on: "2020-12-05",
    client_name: "Magna Et Corporation",
    name: "Donec egestas. Aliquam",
  },
  {
    client_id: 2,
    description: "mauris blandit mattis. Cras eget",
    project_number: "P-15",
    id: 15,
    color: "#5bd8a4",
    is_favorite: false,
    last_updated_on: "2019-09-24",
    client_name: "Ligula Aliquam Erat PC",
    name: "mi lacinia mattis.",
  },
  {
    client_id: 2,
    description:
      "magnis dis parturient montes, nascetur ridiculus mus. Proin vel arcu eu",
    project_number: "P-16",
    id: 16,
    color: "#9dd6dd",
    is_favorite: false,
    last_updated_on: "2021-01-17",
    client_name: "Ipsum Sodales Limited",
    name: "enim.",
  },
  {
    client_id: 1,
    description: "Donec dignissim magna a tortor.",
    project_number: "P-17",
    id: 17,
    color: "#a5fc4e",
    is_favorite: false,
    last_updated_on: "2020-01-23",
    client_name: "Fringilla Corporation",
    name: "dolor.",
  },
  {
    client_id: 1,
    description: "nisl arcu iaculis enim,",
    project_number: "P-18",
    id: 18,
    color: "#db78a5",
    is_favorite: false,
    last_updated_on: "2022-01-04",
    client_name: "Cum Sociis PC",
    name: "amet lorem semper",
  },
  {
    client_id: 2,
    description: "dignissim pharetra. Nam ac nulla. In tincidunt congue",
    project_number: "P-19",
    id: 19,
    color: "#edade4",
    is_favorite: true,
    last_updated_on: "2020-04-04",
    client_name: "In Felis PC",
    name: "tincidunt vehicula",
  },
  {
    client_id: 2,
    description: "dolor vitae dolor. Donec fringilla. Donec feugiat metus sit",
    project_number: "P-20",
    id: 20,
    color: "#65f7dc",
    is_favorite: true,
    last_updated_on: "2021-02-06",
    client_name: "Diam Duis Mi LLC",
    name: "orci, consectetuer",
  },
  {
    client_id: 1,
    description: "eu arcu. Morbi sit amet",
    project_number: "P-21",
    id: 21,
    color: "#44f476",
    is_favorite: true,
    last_updated_on: "2019-11-16",
    client_name: "Per Inceptos Hymenaeos Consulting",
    name: "In at",
  },
  {
    client_id: 1,
    description:
      "vitae semper egestas, urna justo faucibus lectus, a sollicitudin orci sem eget massa.",
    project_number: "P-22",
    id: 22,
    color: "#6df98c",
    is_favorite: false,
    last_updated_on: "2020-05-02",
    client_name: "Nam Corporation",
    name: "arcu. Sed eu nibh",
  },
  {
    client_id: 2,
    description: "lorem vitae odio sagittis semper. Nam tempor",
    project_number: "P-23",
    id: 23,
    color: "#8dcee0",
    is_favorite: true,
    last_updated_on: "2020-05-13",
    client_name: "Integer Foundation",
    name: "imperdiet non, vestibulum",
  },
  {
    client_id: 2,
    description: "nonummy ipsum non arcu. Vivamus sit amet",
    project_number: "P-24",
    id: 24,
    color: "#60a7bc",
    is_favorite: false,
    last_updated_on: "2022-03-06",
    client_name: "Quam Curabitur Institute",
    name: "Suspendisse aliquet,",
  },
  {
    client_id: 1,
    description:
      "per conubia nostra, per inceptos hymenaeos. Mauris ut quam vel",
    project_number: "P-25",
    id: 25,
    color: "#2edb53",
    is_favorite: false,
    last_updated_on: "2022-02-12",
    client_name: "Mus Donec Industries",
    name: "pharetra ut,",
  },
];

export const invoices = [
  {
    id: 1,
    name: "FAKTURA-1",
    due_on: "Oct 3, 2022",
    status: "sent",
    client_name: "Sem Pellentesque Associates",
    amount: "$1,011.18",
    left_to_pay: "$265.27",
  },
  {
    id: 2,
    name: "FAKTURA-2",
    due_on: "Mar 5, 2022",
    status: "sent",
    client_name: "Proin Nisl Associates",
    amount: "$494.28",
    left_to_pay: "$0.00",
  },
  {
    id: 3,
    name: "FAKTURA-3",
    due_on: "Oct 11, 2022",
    status: "sent",
    client_name: "Pellentesque Institute",
    amount: "$1,992.91",
    left_to_pay: "$296.42",
  },
  {
    id: 4,
    name: "FAKTURA-4",
    due_on: "Aug 2, 2023",
    status: "paid",
    client_name: "Tellus Lorem Limited",
    amount: "$1,030.06",
    left_to_pay: "$63.33",
  },
  {
    id: 5,
    name: "FAKTURA-5",
    due_on: "Sep 8, 2021",
    status: "paid",
    client_name: "Velit Quisque Varius Institute",
    amount: "$758.79",
    left_to_pay: "$339.50",
  },
  {
    id: 6,
    name: "FAKTURA-6",
    due_on: "Mar 2, 2023",
    status: "paid",
    client_name: "Tempor Bibendum Foundation",
    amount: "$900.49",
    left_to_pay: "$241.70",
  },
  {
    id: 7,
    name: "FAKTURA-7",
    due_on: "Mar 22, 2023",
    status: "unsent",
    client_name: "Vivamus Euismod Urna Incorporated",
    amount: "$1,953.28",
    left_to_pay: "$280.59",
  },
  {
    id: 8,
    name: "FAKTURA-8",
    due_on: "May 22, 2023",
    status: "unsent",
    client_name: "Nullam Scelerisque Ltd",
    amount: "$677.23",
    left_to_pay: "$195.79",
  },
  {
    id: 9,
    name: "FAKTURA-9",
    due_on: "Mar 7, 2023",
    status: "unsent",
    client_name: "Lectus Pede LLC",
    amount: "$1,963.17",
    left_to_pay: "$182.12",
  },
  {
    id: 10,
    name: "FAKTURA-10",
    due_on: "Nov 19, 2022",
    status: "sent",
    client_name: "Mollis Lectus Incorporated",
    amount: "$858.39",
    left_to_pay: "$211.45",
  },
  {
    id: 11,
    name: "FAKTURA-11",
    due_on: "Jul 10, 2022",
    status: "sent",
    client_name: "Vivamus Molestie Institute",
    amount: "$810.38",
    left_to_pay: "$282.49",
  },
  {
    id: 12,
    name: "FAKTURA-12",
    due_on: "Jan 7, 2022",
    status: "sent",
    client_name: "Nibh LLC",
    amount: "$1,624.77",
    left_to_pay: "$61.21",
  },
  {
    id: 13,
    name: "FAKTURA-13",
    due_on: "Apr 20, 2023",
    status: "paid",
    client_name: "Adipiscing Non Incorporated",
    amount: "$1,195.91",
    left_to_pay: "$178.53",
  },
  {
    id: 14,
    name: "FAKTURA-14",
    due_on: "Apr 11, 2023",
    status: "paid",
    client_name: "Fringilla Institute",
    amount: "$1,866.40",
    left_to_pay: "$180.73",
  },
  {
    id: 15,
    name: "FAKTURA-15",
    due_on: "Sep 2, 2021",
    status: "paid",
    client_name: "Nam Tempor LLP",
    amount: "$697.59",
    left_to_pay: "$348.83",
  },
  {
    id: 16,
    name: "FAKTURA-16",
    due_on: "Aug 20, 2021",
    status: "unsent",
    client_name: "Sed Dictum Corp.",
    amount: "$737.06",
    left_to_pay: "$330.07",
  },
  {
    id: 17,
    name: "FAKTURA-17",
    due_on: "Jun 16, 2022",
    status: "unsent",
    client_name: "Arcu Institute",
    amount: "$1,862.20",
    left_to_pay: "$286.15",
  },
  {
    id: 18,
    name: "FAKTURA-18",
    due_on: "Jun 12, 2022",
    status: "unsent",
    client_name: "Gravida LLP",
    amount: "$1,427.55",
    left_to_pay: "$146.06",
  },
  {
    id: 19,
    name: "FAKTURA-19",
    due_on: "Oct 21, 2021",
    status: "sent",
    client_name: "Tortor Foundation",
    amount: "$1,210.87",
    left_to_pay: "$363.74",
  },
  {
    id: 20,
    name: "FAKTURA-20",
    due_on: "Mar 27, 2022",
    status: "sent",
    client_name: "At Lacus Quisque Incorporated",
    amount: "$1,403.53",
    left_to_pay: "$5.22",
  },
  {
    id: 21,
    name: "FAKTURA-21",
    due_on: "Dec 4, 2022",
    status: "sent",
    client_name: "Malesuada Fames Ac Corp.",
    amount: "$1,687.57",
    left_to_pay: "$351.50",
  },
  {
    id: 22,
    name: "FAKTURA-22",
    due_on: "Jun 24, 2022",
    status: "paid",
    client_name: "Cursus A Industries",
    amount: "$654.17",
    left_to_pay: "$14.41",
  },
  {
    id: 23,
    name: "FAKTURA-23",
    due_on: "Dec 20, 2022",
    status: "paid",
    client_name: "Parturient Montes Nascetur Ltd",
    amount: "$1,427.27",
    left_to_pay: "$308.31",
  },
  {
    id: 24,
    name: "FAKTURA-24",
    due_on: "Jan 7, 2023",
    status: "paid",
    client_name: "Faucibus Morbi Ltd",
    amount: "$1,975.22",
    left_to_pay: "$388.20",
  },
  {
    id: 25,
    name: "FAKTURA-25",
    due_on: "Jan 15, 2022",
    status: "unsent",
    client_name: "Amet Consulting",
    amount: "$994.62",
    left_to_pay: "$47.93",
  },
  {
    id: 26,
    name: "FAKTURA-26",
    due_on: "Oct 3, 2021",
    status: "unsent",
    client_name: "A Associates",
    amount: "$605.78",
    left_to_pay: "$60.72",
  },
  {
    id: 27,
    name: "FAKTURA-27",
    due_on: "Dec 13, 2021",
    status: "unsent",
    client_name: "Purus Maecenas Libero Corp.",
    amount: "$1,086.39",
    left_to_pay: "$19.75",
  },
  {
    id: 28,
    name: "FAKTURA-28",
    due_on: "Oct 18, 2022",
    status: "sent",
    client_name: "Malesuada Foundation",
    amount: "$961.21",
    left_to_pay: "$300.66",
  },
  {
    id: 29,
    name: "FAKTURA-29",
    due_on: "Jan 10, 2022",
    status: "sent",
    client_name: "Quisque Ac Corporation",
    amount: "$1,542.59",
    left_to_pay: "$193.12",
  },
  {
    id: 30,
    name: "FAKTURA-30",
    due_on: "Apr 26, 2023",
    status: "sent",
    client_name: "Nunc Mauris Sapien Ltd",
    amount: "$1,303.73",
    left_to_pay: "$271.74",
  },
  {
    id: 31,
    name: "FAKTURA-31",
    due_on: "Dec 18, 2022",
    status: "paid",
    client_name: "Suspendisse Ac Metus Corp.",
    amount: "$1,384.78",
    left_to_pay: "$15.69",
  },
  {
    id: 32,
    name: "FAKTURA-32",
    due_on: "Apr 12, 2022",
    status: "paid",
    client_name: "Enim Mauris Quis Corp.",
    amount: "$1,048.01",
    left_to_pay: "$41.73",
  },
  {
    id: 33,
    name: "FAKTURA-33",
    due_on: "Jul 22, 2023",
    status: "paid",
    client_name: "Massa Corporation",
    amount: "$1,599.77",
    left_to_pay: "$119.40",
  },
  {
    id: 34,
    name: "FAKTURA-34",
    due_on: "Mar 18, 2022",
    status: "unsent",
    client_name: "Adipiscing Fringilla Porttitor PC",
    amount: "$1,737.14",
    left_to_pay: "$204.63",
  },
  {
    id: 35,
    name: "FAKTURA-35",
    due_on: "Nov 20, 2021",
    status: "unsent",
    client_name: "Elit Dictum Eu Foundation",
    amount: "$798.95",
    left_to_pay: "$185.70",
  },
  {
    id: 36,
    name: "FAKTURA-36",
    due_on: "Jul 9, 2022",
    status: "unsent",
    client_name: "Enim Sed Nulla Ltd",
    amount: "$1,670.64",
    left_to_pay: "$148.63",
  },
  {
    id: 37,
    name: "FAKTURA-37",
    due_on: "Mar 16, 2023",
    status: "sent",
    client_name: "Mollis Duis Sit PC",
    amount: "$682.21",
    left_to_pay: "$182.26",
  },
  {
    id: 38,
    name: "FAKTURA-38",
    due_on: "Oct 11, 2022",
    status: "sent",
    client_name: "Purus Nullam Scelerisque Industries",
    amount: "$1,890.87",
    left_to_pay: "$181.64",
  },
  {
    id: 39,
    name: "FAKTURA-39",
    due_on: "Jun 16, 2023",
    status: "sent",
    client_name: "Sit Amet Ltd",
    amount: "$406.97",
    left_to_pay: "$278.99",
  },
  {
    id: 40,
    name: "FAKTURA-40",
    due_on: "May 31, 2023",
    status: "paid",
    client_name: "Elit Pretium Et Consulting",
    amount: "$1,888.87",
    left_to_pay: "$226.69",
  },
  {
    id: 41,
    name: "FAKTURA-41",
    due_on: "Nov 26, 2022",
    status: "paid",
    client_name: "Parturient Montes Nascetur LLP",
    amount: "$1,765.98",
    left_to_pay: "$35.52",
  },
  {
    id: 42,
    name: "FAKTURA-42",
    due_on: "Feb 21, 2022",
    status: "paid",
    client_name: "Tellus Id Foundation",
    amount: "$1,990.64",
    left_to_pay: "$245.96",
  },
  {
    id: 43,
    name: "FAKTURA-43",
    due_on: "Oct 13, 2022",
    status: "unsent",
    client_name: "Erat Nonummy Company",
    amount: "$1,746.55",
    left_to_pay: "$47.84",
  },
  {
    id: 44,
    name: "FAKTURA-44",
    due_on: "Apr 15, 2023",
    status: "unsent",
    client_name: "Morbi Tristique PC",
    amount: "$1,954.63",
    left_to_pay: "$232.97",
  },
  {
    id: 45,
    name: "FAKTURA-45",
    due_on: "Nov 5, 2021",
    status: "unsent",
    client_name: "Consectetuer Corp.",
    amount: "$1,703.95",
    left_to_pay: "$276.89",
  },
  {
    id: 46,
    name: "FAKTURA-46",
    due_on: "Jul 20, 2022",
    status: "sent",
    client_name: "A Industries",
    amount: "$1,370.17",
    left_to_pay: "$279.29",
  },
  {
    id: 47,
    name: "FAKTURA-47",
    due_on: "Aug 18, 2021",
    status: "sent",
    client_name: "In Faucibus Incorporated",
    amount: "$1,189.67",
    left_to_pay: "$344.31",
  },
  {
    id: 48,
    name: "FAKTURA-48",
    due_on: "Mar 2, 2023",
    status: "sent",
    client_name: "Venenatis A Foundation",
    amount: "$1,544.64",
    left_to_pay: "$350.20",
  },
  {
    id: 49,
    name: "FAKTURA-49",
    due_on: "May 28, 2023",
    status: "paid",
    client_name: "Nulla Integer Urna Foundation",
    amount: "$1,829.31",
    left_to_pay: "$358.11",
  },
  {
    id: 50,
    name: "FAKTURA-50",
    due_on: "May 17, 2022",
    status: "paid",
    client_name: "Nulla Tincidunt Neque Limited",
    amount: "$1,170.30",
    left_to_pay: "$155.84",
  },
];

export const notes = [
  {
    id: 1,
    name: "Quisque fringilla",
    is_collection: true,
    created_by: "Alea Clemons",
    date: "Nov 22, 2022",
  },
  {
    id: 2,
    name: "malesuada fames",
    is_collection: false,
    created_by: "Perry Holt",
    date: "Mar 5, 2022",
  },
  {
    id: 3,
    name: "arcu. Nunc mauris.",
    is_collection: true,
    created_by: "Carlos Rodgers",
    date: "Oct 2, 2021",
  },
  {
    id: 4,
    name: "lorem",
    is_collection: false,
    created_by: "Eaton Sloan",
    date: "Dec 5, 2022",
  },
  {
    id: 5,
    name: "pede nec ante",
    is_collection: false,
    created_by: "Channing Gray",
    date: "Jun 16, 2023",
  },
  {
    id: 6,
    name: "blandit congue. In scelerisque",
    is_collection: true,
    created_by: "Byron Davenport",
    date: "Feb 19, 2022",
  },
  {
    id: 7,
    name: "convallis",
    is_collection: true,
    created_by: "Walter Mcbride",
    date: "Apr 9, 2023",
  },
  {
    id: 8,
    name: "Quisque porttitor",
    is_collection: true,
    created_by: "Galena Rollins",
    date: "Mar 5, 2023",
  },
  {
    id: 9,
    name: "nisi magna sed",
    is_collection: false,
    created_by: "Brooke Padilla",
    date: "Dec 16, 2022",
  },
  {
    id: 10,
    name: "Sed molestie.",
    is_collection: false,
    created_by: "Rosalyn Brady",
    date: "Feb 12, 2023",
  },
  {
    id: 11,
    name: "vitae velit egestas",
    is_collection: true,
    created_by: "Jonas Johns",
    date: "Jul 1, 2022",
  },
  {
    id: 12,
    name: "Phasellus nulla.",
    is_collection: true,
    created_by: "Brooke Mooney",
    date: "Jan 12, 2022",
  },
  {
    id: 13,
    name: "Nulla eu neque pellentesque",
    is_collection: false,
    created_by: "Katelyn Mullen",
    date: "Nov 30, 2022",
  },
  {
    id: 14,
    name: "tincidunt nibh. Phasellus nulla.",
    is_collection: true,
    created_by: "Lunea Peterson",
    date: "Oct 15, 2021",
  },
  {
    id: 15,
    name: "neque venenatis lacus.",
    is_collection: true,
    created_by: "Zachery Huber",
    date: "Nov 20, 2022",
  },
];

export const folders = [
  {
    id: 1,
    name: "nostra, per inceptos",
    has_children: true,
  },
  {
    id: 2,
    name: "vulputate,",
    has_children: false,
  },
  {
    id: 3,
    name: "velit. Pellentesque ultricies",
    has_children: false,
  },
  {
    id: 4,
    name: "quis",
    has_children: false,
  },
  {
    id: 5,
    name: "Fusce mi",
    has_children: true,
  },
  {
    id: 6,
    name: "egestas rhoncus. Proin",
    has_children: false,
  },
  {
    id: 7,
    name: "In lorem. Donec elementum,",
    has_children: false,
  },
  {
    id: 8,
    name: "lacinia orci,",
    has_children: true,
  },
  {
    id: 9,
    name: "ipsum.",
    has_children: false,
  },
  {
    id: 10,
    name: "semper auctor. Mauris",
    has_children: true,
  },
];

export const files = [
  {
    id: 1,
    name: "consectetuer euismod est arcu",
    has_children: false,
    url: "https://via.placeholder.com/200",
    created_by: "Porter Mcclain",
    size: 304,
    date: "29. Mar",
  },
  {
    id: 2,
    name: "dolor sit",
    has_children: false,
    url: "https://via.placeholder.com/150",
    created_by: "Judah Rivera",
    size: 127,
    date: "01. Nov",
  },
  {
    id: 3,
    name: "nonummy. Fusce fermentum",
    has_children: true,
    url: "https://via.placeholder.com/80",
    created_by: "Tanner White",
    size: 457,
    date: "12. Nov",
  },
  {
    id: 4,
    name: "fringilla cursus",
    has_children: false,
    url: "https://via.placeholder.com/200",
    created_by: "Herrod Sutton",
    size: 434,
    date: "10. Mar",
  },
  {
    id: 5,
    name: "vel",
    has_children: false,
    url: "https://via.placeholder.com/80",
    created_by: "Claire Simpson",
    size: 394,
    date: "17. Oct",
  },
  {
    id: 6,
    name: "rhoncus. Proin",
    has_children: true,
    url: "https://via.placeholder.com/150",
    created_by: "Ina Simmons",
    size: 785,
    date: "05. Jul",
  },
  {
    id: 7,
    name: "lobortis. Class",
    has_children: false,
    url: "https://via.placeholder.com/150",
    created_by: "Fleur Charles",
    size: 356,
    date: "12. Jul",
  },
  {
    id: 8,
    name: "vel, vulputate",
    has_children: true,
    url: "https://via.placeholder.com/200",
    created_by: "Hadley Boyer",
    size: 753,
    date: "03. Jul",
  },
  {
    id: 9,
    name: "Suspendisse sed dolor. Fusce",
    has_children: true,
    url: "https://via.placeholder.com/80",
    created_by: "Shelby Humphrey",
    size: 556,
    date: "22. Sep",
  },
  {
    id: 10,
    name: "mauris",
    has_children: true,
    url: "https://via.placeholder.com/80",
    created_by: "Winter George",
    size: 765,
    date: "31. Aug",
  },
];
